import React from 'react';
import './Tips.css';

const Tips = () => {
  return (
    <div className="container">
      <div style={{ padding: '40px 20px', lineHeight: '1.6' }}>
        <h1 style={{ textAlign: 'center', marginBottom: '30px' }}>
          TIPS ON HOW TO PLAY UK49'S LOTTERY LOTTO, POWERBALL AND GOSLOTTO
        </h1>

        {/* UK49's Section */}
        <section style={{ marginBottom: '40px', padding: '20px', backgroundColor: '#f8f9fa', borderRadius: '8px' }}>
          <h2 style={{ color: '#2c3e50', marginBottom: '20px', borderBottom: '2px solid #3498db', paddingBottom: '10px' }}>
            TIPS ON HOW TO PLAY UK49'S LOTTERY LOTTO GAME
          </h2>
          
          <p>
            UK49's Lottery Lotto was parted into two draw game, which is LUNCHTIME DRAW and TEATIME DRAW. 
            UK49's Lunchtime and Teatime is a draw game where six main numbers and a Booster Ball are drawn 
            from a pool of 1 to 49 and it takes place everyday. Your goal is to match numbers with those 
            randomly selected in a given draw. In order for you to win, whichever number/s you choose needs 
            to be drawn. If you pick one number, it needs to be drawn in order for you to win. If you pick 
            three numbers, all three must be drawn in order for your bet to win. Remember that to win you 
            must match all the numbers you pick, but the more numbers you pick, the bigger the prize. 
            Choose your numbers from a range between 1 to 49. Set the amount you would like to wager. 
            Players have the choice of placing a R3, R5 or R10 bet and payouts are dependent on the bet 
            amount selected. UK49's Teatime Pick 1 pays out from R18 up to R60. If you match 1 number. 
            Teatime Pick 2 offers a payout from R90 to R3000, if you match two numbers.......................... 
            If your chosen number is drawn as the Bonus Ball, you are a winner! You will win 5.7 * your stake back.
          </p>

          <h3 style={{ color: '#2c3e50', marginTop: '25px', marginBottom: '15px' }}>
            HOW DO I BET ON UK49's (Lunchtime and Teatime game)
          </h3>
          <p>
            The amount you bet and the various outcomes you choose to predict are for you to decide. 
            When playing UK49'S, you can choose to predict the outcome of 1 balls, 2 balls, 3 balls, 4 balls, 
            5 balls or 6 balls drawn at various odds, depending on whether your bet includes the bonus ball or not. 
            There's two ways where you can bet UK49's, BETTINGSHOP or ONLINE with your mobile phone[ Betway app, 
            Hollywoodbet app, Supabet app.........].
          </p>

          <h3 style={{ color: '#2c3e50', marginTop: '25px', marginBottom: '15px' }}>
            WHY DO I ALWAYS LOSE BETS
          </h3>
          <p>
            Greed leads to losses almost always! Every gambler has made a wrong decision in the past that left them feeling hard. 
            Chasing losses is when you bet on an outcome with heavy odds to win back your money, one of the most dangerous habits for gamblers. 
            It leads to long loosing streaks and expensive mistakes. Lack of trusting and doubting, can cause dooming as well. 
            You have to trust and believe A punter or A winning platform like our platform (OLYMPIC WINNING PLATFORM).
          </p>

          <h3 style={{ color: '#2c3e50', marginTop: '25px', marginBottom: '15px' }}>
            WHAT TIME IS UK49'S LUNCHTIME AND TEATIME DRAW
          </h3>
          <p>
            What is Lunchtime Results? The Lunchtime results is the result of the UK49's draw that is held at <strong>13:49pm South Africa time</strong>. 
            The Teatime draw is held at <strong>18:49pm South Africa time</strong>.
          </p>

          <h3 style={{ color: '#2c3e50', marginTop: '25px', marginBottom: '15px' }}>
            WHAT ARE THE LUCKIEST NUMBER COMES OUT THE MOST ON UK49's Lunchtime and Teatime
          </h3>
          <p>
            According to our platform calculations, the lucky number for UK49's lottery lotto is: 
            <strong> 03, 07, 09, 11, 12, 13, 20, 47</strong>
          </p>

          <h3 style={{ color: '#2c3e50', marginTop: '25px', marginBottom: '15px' }}>
            WHAT TO DO TO START WINNING BIGGER EVERYDAY
          </h3>
          <p style={{ backgroundColor: '#e8f5e9', padding: '15px', borderRadius: '5px', borderLeft: '4px solid #4caf50' }}>
            You have to <strong>REGISTER with our Platform (OLYMPIC WINNING PLATFORM)</strong> to start winning bigger everyday for you to be among the winner's everyday, 
            to stand a chance to <strong>WIN R30,000 upwards</strong> on Lunchtime and Teatime game everyday. 
            Trust me winning is 100% sure and guaranteed on our platform, you have nothing to worry or scared about. 
            You're safe with our platform and easy to register with our platform. Kindly, click on the <strong>REGISTRATION PAGE</strong> on the platform page and registered 
            or WhatsApp contact an agent <strong>+27 73 704 2669</strong>.
          </p>
        </section>

        {/* SA Powerball Section */}
        <section style={{ marginBottom: '40px', padding: '20px', backgroundColor: '#f8f9fa', borderRadius: '8px' }}>
          <h2 style={{ color: '#2c3e50', marginBottom: '20px', borderBottom: '2px solid #e74c3c', paddingBottom: '10px' }}>
            TIPS ON HOW TO PLAY SA POWERBALL GAME
          </h2>
          
          <p>
            Learn how to play SA PowerBall with the step-by-step guide below. You can take part online, in stores or via certain other services, 
            such as through the FNB website and mobile app. Draws are held every Tuesday and Friday at 20:58 and here's what you need to do to enter. 
            Choose five main numbers from 1 to 50, plus a PowerBall from 1 to 20. Your PowerBall can even be the same as one of your main numbers 
            because it is selected from a different set. You just need to mark your choices on your betslip if you play in-store. Online, simply select 
            the numbers you want to play. If you'd rather have random numbers, choose the Quick Pick option. If you wish to play more than one set of numbers, 
            move on to the next board on your betslip and choose another five main numbers and a PowerBall. You can choose your own numbers or select a 
            Quick Pick on each individual board. You can play as many boards as you want and spend up to a maximum of R2,000 per ticket. It costs R5 for 
            each set of PowerBall numbers. You can enter your numbers into just the next draw or take advantage of the Multi-Draw option to submit your 
            entries for up to 10 games in advance. It's a quick way to enter more than one draw ahead of time, but you just need to make sure you keep 
            hold of your ticket, as a single one will be issued to cover all the draws. If you play online, your numbers will be stored in your account. 
            Don't forget to add PowerBall Plus to your ticket if you want to give yourself more chances to win. All you need to do is select the PowerBall 
            Plus option on your betslip or online. For an additional fee of R2.50 per play, the selections you make for PowerBall will be entered into 
            the supplementary PowerBall Plus draw. This includes all additional sets of numbers and Multi-Draw purchases. Take a moment to check over your 
            betslip or online selections, then it's time to pay for your entries. If you're in a store, take your betslip to the teller to purchase your ticket. 
            If you're online, you'll need to make sure you have the funds in your player account to pay. The cut-off time for playing PowerBall is 20:30 on 
            draw days, leaving you just half an hour to wait to find out if you are a winner.
          </p>

          <h3 style={{ color: '#2c3e50', marginTop: '25px', marginBottom: '15px' }}>
            WHAT ARE THE LUCKIEST NUMBER COMES OUT THE MOST ON SA POWERBALL
          </h3>
          <p>
            According to our platform calculations, the lucky number for the main number is: 
            <strong> 03, 07, 15, 24, 34, 01</strong>. For the Powerball numbers, it has been: 
            <strong> 03, 04, 11, 14, 18, 20</strong>.
          </p>

          <h3 style={{ color: '#2c3e50', marginTop: '25px', marginBottom: '15px' }}>
            WHAT TIME IS SA POWERBALL DRAW
          </h3>
          <p>
            Powerball drawings have been held two times a week on <strong>Tuesday and Friday at 20:58 p.m.</strong>
          </p>

          <h3 style={{ color: '#2c3e50', marginTop: '25px', marginBottom: '15px' }}>
            WHAT TO DO TO START WINNING BIGGER ON EVERY DRAW
          </h3>
          <p style={{ backgroundColor: '#e8f5e9', padding: '15px', borderRadius: '5px', borderLeft: '4px solid #4caf50' }}>
            You have to <strong>REGISTER with our Platform (OLYMPIC WINNING PLATFORM)</strong> to start winning bigger everyday for you to be among the winner's everyday, 
            to stand a chance to <strong>WIN R30,000 upwards</strong> on each Draw. Trust me winning is 100% sure and guaranteed on our platform, you have nothing to worry or scared about. 
            You're safe with our platform and easy to register with our platform. Kindly, click on the <strong>REGISTRATION PAGE</strong> on the platform page and registered 
            or WhatsApp contact an agent <strong>+27 73 704 2669</strong>.
          </p>
        </section>

        {/* Russia Goslotto Section */}
        <section style={{ marginBottom: '40px', padding: '20px', backgroundColor: '#f8f9fa', borderRadius: '8px' }}>
          <h2 style={{ color: '#2c3e50', marginBottom: '20px', borderBottom: '2px solid #9b59b6', paddingBottom: '10px' }}>
            TIPS ON HOW TO PLAY RUSSIA GOSLOTTO (5/36 Draw, 6/45 Draw, 7/49 Draw)
          </h2>
          
          <p>
            A simple, fun and generous. Russia Goslotto is one of the most highly favored lottery games among South African Lucky Numbers players. 
            The lottery is an excellent pick for every novice punter due to its straightforward rules, high frequency of draws and a vast array of lucrative bet types. 
            Here is more about how Russia Goslotto plays and what formats it offers. The three main types of Russia Goslotto draws available on online betting platforms 
            such as YesPlay include:
          </p>

          <div style={{ marginLeft: '20px' }}>
            <h4 style={{ color: '#2c3e50', marginTop: '20px' }}>Russia Goslotto 5/36</h4>
            <p>
              - a single-ball set game that draws every 30 minutes, every day of the week. There are five number drawn from the pool of 36 balls, 
              and correctly predicting between 1 and 4 numbers will grant players a payout with various multipliers. When you play the Russia Goslotto 
              in South Africa, there is no option to bet on the bonus ball.
            </p>
            
            <h5 style={{ color: '#2c3e50', marginTop: '15px' }}>RUSSIA GOSLOTTO 5/36 DRAW TIMES IN SOUTH AFRICA</h5>
            <p>12h00, 12h30, 13h00, 13h30, 14h00, 14h30, 15h00 Etc........</p>

            <h4 style={{ color: '#2c3e50', marginTop: '20px' }}>Russia Goslotto 6/45 Draw</h4>
            <p>
              - a single-ball set game that plays twice daily at 11:00 and 23:00 depending on the time of year. Guessing between 1 and 5 numbers out of 
              the total of six balls drawn guarantees a handsome payout to the lucky bettor. When you play the Russia Goslotto in South Africa, there is 
              no option to bet on the bonus ball.
            </p>
            
            <h5 style={{ color: '#2c3e50', marginTop: '15px' }}>RUSSIA GOSLOTTO 6/45 DRAW TIMES IN SOUTH AFRICA</h5>
            <p>11h00, 23:00 (depending on the same of year)</p>

            <h4 style={{ color: '#2c3e50', marginTop: '20px' }}>Russia Goslotto 7/49 Draw</h4>
            <p>
              - takes place 5 times per day, 7 days a week. A single ball set is used with each ball numbered between 1 and 49. How it works is that 7 balls 
              are drawn from the drum and you must predict between 1 and 6 numbers depending on what kind of bet you want to place. When you play the Russia 
              Goslotto in South Africa, there is no option to bet on the bonus ball.
            </p>
            
            <h5 style={{ color: '#2c3e50', marginTop: '15px' }}>RUSSIA GOSLOTTO 7/49 DRAW TIMES IN SOUTH AFRICA</h5>
            <p>10h30, 22:30 (depending on the same of year)</p>
          </div>

          <h3 style={{ color: '#2c3e50', marginTop: '25px', marginBottom: '15px' }}>
            WHAT ARE THE LUCKIEST NUMBER COMES OUT THE MOST ON RUSSIA GOSLOTTO
          </h3>
          <p>
            According to our platform calculations, the lucky number for Russia Goslotto (all draws) is: 
            <strong> 01, 02, 11, 03, 21, 31, 41, 07</strong>
          </p>

          <h3 style={{ color: '#2c3e50', marginTop: '25px', marginBottom: '15px' }}>
            WHAT TO DO TO START WINNING BIGGER ON EVERY DRAW
          </h3>
          <p style={{ backgroundColor: '#e8f5e9', padding: '15px', borderRadius: '5px', borderLeft: '4px solid #4caf50' }}>
            You have to <strong>REGISTER with our Platform (OLYMPIC WINNING PLATFORM)</strong> to start winning bigger everyday for you to be among the winner's everyday, 
            to stand a chance to <strong>WIN R30,000 upwards</strong> on each Draw. Trust me winning is 100% sure and guaranteed on our platform, you have nothing to worry or scared about. 
            You're safe with our platform and easy to register with our platform. Kindly, click on the <strong>REGISTRATION PAGE</strong> on the platform page and registered 
            or WhatsApp contact an agent <strong>+27 73 704 2669</strong>.
          </p>
        </section>

        {/* Contact Information */}
        <section style={{ padding: '20px', backgroundColor: '#2c3e50', color: 'white', borderRadius: '8px', textAlign: 'center' }}>
          <h3 style={{ marginBottom: '15px' }}>CONTACT INFORMATION</h3>
          <p style={{ margin: '10px 0' }}>
            <strong>GMAIL CONTACT:</strong> olympicwinningplatform@gmail.com
          </p>
          <p style={{ margin: '10px 0' }}>
            <strong>WHATSAPP:</strong> +27 73 704 2669
          </p>
        </section>
      </div>
    </div>
  );
};

export default Tips;
